import React, { memo, useState } from 'react';

import Popover from 'components/shared/Popovers/Popover/Popover';

const SelectCellEditor = memo(({ value, options, onValueChange }) => {
  const [inputValue, setInputValue] = useState(value);

  const handleOptionClick = (option) => {
    setInputValue(option.value);
    if (onValueChange) {
      onValueChange(option.value);
    }
  };

  return (
    <Popover
      isFixed
      isDropdown
      icon={false}
      position="left"
      text={options.find((option) => option.value === inputValue)?.label || 'Select...'}
      options={options}
      onOptionClick={handleOptionClick}
      panelClassName="z-[100] min-w-[126px] rounded-none"
      textClassName="text-neutral-900 font-400 text-nowrap w-full"
      className="w-full"
      buttonTheme="secondary"
      buttonClassName="!px-2 w-full text-left h-[39px] rounded-none"
      activeClassNames={{ button: 'bg-neutral-100 border border-solid border-neutral-200' }}
    />
  );
});

SelectCellEditor.displayName = 'SelectCellEditor';

export default SelectCellEditor;
